import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';


@Component({
    selector: 'support-drivers',
    templateUrl: './support-drivers.component.html',
    styleUrls: ['./support-drivers.component.scss'],
    providers: [MessageService]
})
export class SupportDriversComponent implements OnInit {
    public selectedDateRange: Date[] = [];

    ngOnInit(): void {
        this.selectedDateRange[1] = new Date();
        this.selectedDateRange[0] = new Date();
        this.selectedDateRange[0].setDate(new Date().getDate() - 30);
    }
}
